import { NativeModules } from 'react-native';
import Constants from './constants';
const { RNSecLib } = NativeModules;
const { ShakingSensitivity, InvocationEvents } = Constants;

class CustomerChannel {
	static isSetup = false;
	// default config
	static initConfig = {
		privacyPolicyUrl: null,
		isWelcomeMessageEnabled: true,
		isAppRatingEnabled: false,
		invocationEvent: InvocationEvents.shake,
		sensitivity: ShakingSensitivity.MEDIUM,
	};

	//config state to track the Current config.
	static currentConfig = {
		...CustomerChannel.initConfig,
	};

	static setup(config) {
		CustomerChannel.isSetup = true;

		CustomerChannel.currentConfig = {
			...CustomerChannel.currentConfig,
			...config,
		};

		const {
			privacyPolicyUrl,
			isWelcomeMessageEnabled,
			isAppRatingEnabled,
			invocationEvent,
			sensitivity,
		} = CustomerChannel.currentConfig;

		RNSecLib.setupCustomerChannel(
			privacyPolicyUrl,
			isWelcomeMessageEnabled,
			isAppRatingEnabled,
			invocationEvent,
			sensitivity,
		);
	}

	static showBugReport() {
		RNSecLib.launchCustomerChannel();
	}

	static showBugReportWelcomeMessage() {
		RNSecLib.showWelcomeMessage();
	}

	static showAppRating() {
		RNSecLib.showAppRating();
	}

	static disable() {
		CustomerChannel.isSetup = false;
		RNSecLib.disableCustomerChannel?.();
		CustomerChannel.currentConfig = { ...CustomerChannel.initConfig };
	}

	static enableAppRate() {
		if (!CustomerChannel.isSetup) {
			console.warn('Please setup the Customer Channel before enabling the App Rate');
			return;
		}
		// this workAround to make user able to enable appRate by disable the customer channel and re-config it with the same config and appRate enable .
		RNSecLib.disableCustomerChannel?.();
		CustomerChannel.setup({ isAppRatingEnabled: true });
	}

	static setBugReportInvocationEvent(invocationEvent) {
		CustomerChannel.currentConfig = {
			...CustomerChannel.currentConfig,
			invocationEvent,
		};
		RNSecLib.setInvocationEvent?.(invocationEvent);
	}

	static setBugReportShakingSensitivity(sensitivity) {
		CustomerChannel.currentConfig = {
			...CustomerChannel.currentConfig,
			sensitivity,
		};
		RNSecLib.setShakingSensitivity?.(sensitivity);
	}
}

export default CustomerChannel;
